import { styled } from '@mui/material/styles';
export const Wrapper = styled('div')(({ hasBorderTop, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3.75, 0),
    fontSize: theme.typography.body2.fontSize,
    borderTop: hasBorderTop ? `1px solid ${theme.palette.black40.main}` : 'none',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: theme.spacing(5, 0, 3.5),
    },
}));
export const FlexContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(5),
    },
}));
export const List = styled('ul')(({ theme }) => ({
    display: 'flex',
    padding: 0,
    margin: 0,
    listStyleType: 'none',
    [theme.breakpoints.down('md')]: {
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
}));
export const ListItem = styled('li')(({ theme }) => ({
    '&:first-child a': {
        paddingLeft: 0,
    },
    '&:last-child a': {
        paddingRight: 0,
    },
    [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(2.5),
    },
}));
export const Link = styled('a')(({ theme }) => ({
    padding: theme.spacing(0, 2.5),
    lineHeight: 1.63,
    color: theme.palette.black80.main,
    textDecoration: 'none',
    '&:hover': {
        color: theme.palette.orange60.main,
        textDecoration: 'underline',
    },
}));
export const Copyright = styled('p')(({ theme }) => ({
    margin: theme.spacing(0, 0, 0, 5),
    lineHeight: 1.63,
    color: theme.palette.black80.main,
    [theme.breakpoints.down('md')]: {
        margin: 0,
    },
}));
//# sourceMappingURL=styles.js.map